import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <header className="bg-white dark:bg-[#18181b] theme-border border-b min-h-[53px] py-2 px-6 flex items-center">
      <div className="flex items-center justify-between w-full gap-4">
        <div className={subtitle ? 'min-w-0' : ''}>
          <h1 className="text-sm font-semibold theme-text">{title}</h1>
          {subtitle && <p className="text-xs theme-text-muted truncate">{subtitle}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </header>
  );
}
